import { isObject, isArray, cloneDeep, isString, isPlainObject } from 'lodash';

export const requestMultiplePage = (callbacks, page) => {
  let tempArr = [];
  for (let eachPage = 0; eachPage < page + 1; eachPage++) {
    tempArr = [...tempArr, callbacks(eachPage)];
  }

  return tempArr;
};

export const correctBodyToRequest = (params = {}, removeNull = false) => {
  const values = cloneDeep(params || {});
  // convert object -> value when from selection
  return Object.keys(values).reduce((obj, key) => {
    obj = {
      ...obj,
      [key]: values[key],
    };

    if (isString(values[key])) {
      obj = {
        ...obj,
        [key]: values[key].trim(),
      };
    }

    if (isPlainObject(values[key]) && values[key].hasOwnProperty('value')) {
      obj = {
        ...obj,
        [key]: values?.[key]?.value,
      };
    }

    if (isArray(values[key])) {
      obj = {
        ...obj,
        [key]: values[key]?.map((el) => el['value']),
      };
    }

    if (removeNull && values[key] === null) {
      delete obj[key];
    }

    return obj;
  }, {});
};
